// import React, { useState } from "react";


// const Pagination= ({
//   totalItems,
//   itemsPerPage,
//   currentPage,
//   onPageChange,
// }) => {
//   const totalPages = Math.ceil(totalItems / itemsPerPage);
//   const [pageGroup, setPageGroup] = useState(0); // Keeps track of the current group of 6 pages

//   const getPageNumbers = () => {
//     const startPage = pageGroup * 4 + 1;
//     const endPage = Math.min(startPage + 3, totalPages);
//     const pages = [];

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(i);
//     }

//     return pages;
//   };

//   const handleLastPage = () => {
//     onPageChange(totalPages);
//     setPageGroup(Math.ceil(totalPages / 4) - 1)
//   }

//   const handleNextGroup = () => {
//     if ((pageGroup + 1) * 4 < totalPages) {
//       setPageGroup(pageGroup + 1);
//     }
//   };

//   const handlePreviousGroup = () => {
//     if (pageGroup > 0) {
//       setPageGroup(pageGroup - 1);
//     }
//   };

//   return (
//     <div className="flex items-center space-x-2">
//       <button
//         className="px-3 py-1 border rounded-md disabled:opacity-50"
//         disabled={currentPage === 1}
//         onClick={() => {
//           setPageGroup(Math.ceil((currentPage - 1) / 4) - 1);
//           onPageChange(currentPage - 1);
//         }}
//       >
//         Prev
//       </button>

//       {pageGroup > 0 && (
//         <button className="px-3 py-1 border rounded-md" onClick={handlePreviousGroup}>
//           ...
//         </button>
//       )}

//       {getPageNumbers().map((page) => (
//         <button
//           key={page}
//           className={`px-3 py-1 border rounded-md ${currentPage === page ? "bg-[#E31c23] text-white" : "bg-white"
//             }`}
//           onClick={() => onPageChange(page)}
//         >
//           {page}
//         </button>
//       ))}

//       {(pageGroup + 1) * 4 < totalPages && (
//         <button className="px-3 py-1 border rounded-md" onClick={handleNextGroup}>
//           ...
//         </button>
//       )}


//       {(pageGroup + 1) * 4 < totalPages && <button
//         className={`px-3 py-1 border rounded-md ${currentPage === totalPages ? "bg-[#E31c23] text-white" : "bg-white"
//           }`}
//         onClick={handleLastPage}
//       >
//         {Math.ceil(totalItems / itemsPerPage)}
//       </button>
//       }

//       <button
//         className="px-3 py-1 border rounded-md disabled:opacity-50"
//         disabled={currentPage === totalPages}
//         onClick={() => {
//           setPageGroup(Math.ceil((currentPage + 1) / 4) - 1);
//           onPageChange(currentPage + 1)
//         }}
//       >
//         Next
//       </button>
//     </div>
//   );
// };

// export default Pagination;



import React, { useContext, useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Button, PaginationItem, TextField,Tooltip } from "@mui/material";
// import Tooltip from '@mui/material/Tooltip';
import { AppContext } from "../context/AppContext";
import { useMediaQuery } from '@mui/material';




const MuiPagination = ({ totalItems, itemsPerPage, currentPage, onPageChange,selectedRows }) => {
  const [inputPage, setInputPage] = useState();
  const { loader } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState();
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const endRecord = Math.min(currentPage * itemsPerPage, totalItems);
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  const theme = createTheme({
    components: {
      MuiPaginationItem: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              backgroundColor: "#B0B0B0", // Grey color
              color: "white",
              borderRadius: "100px",
               minWidth:isSmallScreen? "12px":"28px", // Reduce width to make it compact
              height: isSmallScreen ? "18px":"28px",
              padding: "0px 2px", // Adjust padding to remove extra space
              margin: "0px 1px", // Reduce outer margin
              fontSize: isSmallScreen? "10px":"12px"
            },
            //   '&:hover': {
            //   backgroundColor: "red", // Red color on hover
            // },
          },
        },
      },
    },
  });
  const handleChange = (event, value) => {
    onPageChange(value);
    setInputPage(""); 
  setErrorMessage("")
  };
  const handleGoClick = () => {
    if (inputPage >= 1 && inputPage <= totalPages) {
      onPageChange(inputPage);
      setErrorMessage(""); 
    } else {
      setErrorMessage("No record found.");
    }
    
  };
  useEffect(()=>{
    if(inputPage === "" ){
      setErrorMessage("")
    }
  },[setErrorMessage,inputPage])
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setInputPage(value ? Number(value) : "");
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleGoClick(); 
    }
  };
  return (
    <div className="flex flex-col font-poppins">
    <ThemeProvider theme={theme}>
      <Stack spacing={1.5} direction="row" alignItems="center" justifyContent="center" >
        { selectedRows>=1 && 
<span className="text-[12px] sm:text-[14px] sm:block hidden "> Selected - {selectedRows}</span>}
        <Typography variant="body2" sx={{fontFamily:"poppins", color:"black",fontSize: { xs: '10px', sm: '14px', }, }}>
        {loader ? "" : `${endRecord || 0} / ${totalItems || 0}`}
        </Typography>
            <Pagination 
              count={totalPages} 
              page={currentPage} 
              onChange={handleChange} 
              color="warning" 
              shape="rounded" 
              siblingCount={isSmallScreen ? 0 : 1} 
              boundaryCount={isSmallScreen ? 0 : 1} 
              showFirstButton 
              defaultValue={[]}
              showLastButton 
              renderItem={(item) => {
                 console.log("item.type:", item.type); 
                 console.log(item,'item')
                 const tooltips = {
                previous: "Previous Page",
                next: "Next Page",
                last: "Last Page",
                first: "First Page",
              };
                const tooltipTitle = tooltips[item.type];
                console.log(tooltipTitle,'tooltipTitle')
                return (
                  <Tooltip title={tooltipTitle} arrow>
                    <PaginationItem {...item} />
                  </Tooltip>
                ) 
              }}
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "black",
                  fontSize: { xs: '8px', sm: '14px' },
                  margin:{xs:"-7px",sm:0 },
                  "&:hover": {
                    backgroundColor: "#E0E0E0", 
                    borderRadius:isSmallScreen ? "20px" : "100px"
                  },
                },
                "& .MuiPaginationItem-page.Mui-selected": {
                  color: "black", 
                  backgroundColor: "#E0E0E0", 
                  "&:hover": {
                    backgroundColor: "#E0E0E0", 
                  },
                },
              }}
    
            />

        
        
       <input
          type="text"
          value={inputPage}
          defaultValue="" 
          className="border border-solid border-neutral-200 font-poppins rounded-md focus:border-blue-500 focus:outline-none p-1 text-[10px] w-[45px] md:w-[72px] md:text-[14px]"
          placeholder="Page No."
          onChange={handleInputChange}
          onKeyDown={handleKeyPress} 
        />
        <button
              className={`font-semibold px-1  text-[10px] sm:text-[14px] md:px-4 py-1 md:py-2 text-white  ${loader ? "bg-[#F87171]" : "bg-red-600"} rounded-md cursor-pointertransition-colors duration-200 active:bg-[#F87171]`}
              onClick={handleGoClick}
            >
              Go
            </button>
      </Stack>
    </ThemeProvider>
    <div className="flex justify-end">
    { selectedRows>=1 && 
      <span className="text-[12px] sm:text-[14px] sm:hidden block font-normal "> Selected - {selectedRows}</span>}
    </div>
    <div className="text-[12px]  flex justify-end font-semibold min-h-[15px] ">
   
    {errorMessage && (
        <p className="text-[#E31c23]">{errorMessage}</p>
     
      )}
    </div>
    </div>
    
  );
};

export default MuiPagination;